module.exports = __webpack_public_path__ + "img/footer.1f603327.png";